export default {
  skill: [
    {
      name: "HTML",
      detail: ["Elements", "Text Formating", "Table", "Etc..."],
    },
    {
      name: "CSS",
      detail: ["Position", "Pseudo", "Effect", "Etc..."],
    },
    {
      name: "Javascript",
      detail: ["Arrow Function", "Async Await", "Array", "Etc..."],
    },
    {
      name: "Typescript",
      detail: ["Type of data", "Event Handler", "Etc..."],
    },
    {
      name: "React",
      detail: ["Lifecycle", "Hooks", "Redux", "Etc..."],
    },
    {
      name: "Node",
      detail: ["Restful API", "Express", "MongoDB", "Etc..."],
    },
    {
      name: "Vue",
      detail: ["Lifecycle", "Slots", "Vuex", "Etc..."],
    },
    {
      name: "Nuxt JS",
      detail: ["Route", "Layout", "Error", "Etc..."],
    },
  ],
  experience: [
    {
      date: "Jan 2022 - Present",
      position: "Frontend Developer",
      company: "Ultra Voucher",
      jobdesk: [
        "Effectively implement client feedback",
        "Maintaining products to ensure optimal performance",
        "Applying UI/UX design from Figma to applications",
        "Optimize applications based on Lighthouse assessment",
      ],
    },
    {
      date: "Oct 2020 - Dec 2021",
      position: "Frontend Developer",
      company: "Prospace",
      jobdesk: [
        "Designs and creates software solutions to solve pain points for various type of clients",
        "Tested and refined software prior to roll out",
        "Design unit testing for the components",
        "In charge of release the application to production",
        "Create UI Framework and release to NPM",
      ],
    },
    {
      date: "Sept 2018 - Sept 2020",
      position: "Frontend Developer",
      company: "Xsis Mitra Utama",
      jobdesk: [
        "Re build Employee Self Service Application from webform to micro service with React Typescript",
        "Maintenance Employee Self Service Application",
        "Fixing bug in existing Employee Self Service website",
        "Add new features and modules to the Application",
      ],
    },
  ],
  education: [
    {
      date: "2012 - 2018",
      grade: "Bachelor of Computer Science",
      school: "Telkom University",
    },
    {
      date: "2009 - 2021",
      grade: "Senior High School",
      school: "SMA Angkasa Bandung",
    },
  ],
};
